import React from 'react';
import LaneContainer from '../UI/LaneContainer';
import LoadingSpinner from '../UI/LoadingSpinner';
import YourBooksSectionHeader from '../YourBooks/YourBooksSectionHeader';
import { connectToRequests } from './containers/RequestsDataStore';
import RequestsCollapse from './RequestsCollapse';
import RequestsMenu from './RequestsMenu';

export class Requests extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showInGrid: false,
		};
	}

	componentDidMount() {
		this.initializeSource();
	}

	initializeSource = () => {
		if (this.props.match) {
			this.setState({ showInGrid: true });
		}
	};

	render() {
		const { showInGrid } = this.state;
		const { isLoading } = this.props.requestsDataStore.state;
		return (
			<div
				style={{
					marginTop: showInGrid ? 64 : 0,
				}}>
				<LaneContainer
					majorHeader={
						<YourBooksSectionHeader
							headerText="Your Requests"
							showInGrid={showInGrid}
						/>
					}>
					<React.Fragment>
						{!isLoading ? (
							<div>
								{showInGrid ? (
									<RequestsMenu />
								) : (
									<RequestsCollapse />
								)}
							</div>
						) : (
							<LoadingSpinner />
						)}
					</React.Fragment>
				</LaneContainer>
			</div>
		);
	}
}

export default connectToRequests(Requests);
